import Component from '../inherited/Component'

export default class AnimationsHalfParallax extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._targetImages = this._elem.querySelectorAll('[data-half-parallax-target-image]')
    this._contentBlocks = this._elem.querySelectorAll('[data-half-parallax-image]')
    this._blockers = this._elem.querySelectorAll('[data-blocker]')
    this._blockerHeight = 0
  }

  mount () {

    window.addEventListener('scroll', () => {
      this._checkOffsetTop()
      this._setBlockersHeight()
    })
  }

  _setBlockersHeight () {    
    for (let blocker of this._blockers) {
      let imageElement = this._elem.querySelector('.half-parallax-image')
      let contentElement = this._elem.querySelector('.right-area')

      let imageElementBottom = imageElement.getBoundingClientRect().bottom
      let contentElementBottom = contentElement.getBoundingClientRect().bottom
      let distance = contentElementBottom - imageElementBottom

      if (distance > 0) {
        this._blockerHeight = imageElement.getBoundingClientRect().top
        blocker.style.height = this._blockerHeight + 'px'
        blocker.style.transform = 'translateY(0)'
      } else {
        if (blocker.classList.contains('blocker-top')) {
          blocker.style.transform = 'translateY(-' + (this._blockerHeight - imageElement.getBoundingClientRect().top) + 'px)'
        }
      }
    }
  }

  _checkOffsetTop () {
    const windowHeight = window.innerHeight

    for (let block of this._contentBlocks) {
      let blockTop = block.getBoundingClientRect().top
      let imageId = block.dataset.halfParallaxImage
      
      if (blockTop < windowHeight / 2) {
        for (let item of this._targetImages) {
          item.classList.remove('active')

          if (item.dataset.halfParallaxTargetImage === imageId) {
            item.classList.add('active')
          }
        }
    
        for (let block of this._contentBlocks) {
          block.classList.remove('active')
        }
        
        block.classList.add('active')
      }
    }
  }
}